/* Page Create Account */
/**
 * It takes a string, checks if it contains a lowercase letter, uppercase letter, number, and if it's
 * between 8 and 20 characters long, and returns an object with the results of those checks
 * @param value - The value of the input field
 * @param setChecks - This is a function that will be used to update the state of the checks object.
 */
export const validateKeyUpPassword = (value) => {
  const uppercaseCheck = /[A-Z]/.test(value)
  const lowercaseCheck = /[a-z]/.test(value)
  const numberCheck = /[0-9]/.test(value)
  const lengthCheck = value.length >= 8 && value.length <= 20
  const spaceCheck = /^\S*$/.test(value)

  return {
    uppercase: uppercaseCheck,
    lowercase: lowercaseCheck,
    number: numberCheck,
    length: lengthCheck,
    space: spaceCheck
  }
}
export const validateAccount = (register) => {
  const { name, surname, mail, password } = register
  const { uppercase, lowercase, number, length, space } = validateKeyUpPassword(password)
  const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/
  const regexEmail = /[-.\w]+@([\w-]+\.)+[\w-]+/g
  const nameSpace = /^\S.*\S$/

  const error = {}

  if (!name) {
    error.name = 'Es necesario que completes este campo.'
  }
  if (!nameSpace.test(name)) {
    error.name = 'No se permiten espacios al inicio y al final.'
  }
  if (!surname) {
    error.surname = 'Es necesario que completes este campo.'
  }
  if (!nameSpace.test(surname)) {
    error.surname = 'No se permiten espacios al inicio y al final.'
  }
  if (!mail) {
    error.mail = 'Es necesario que completes este campo.'
  } else if (!regexEmail.test(mail)) {
    error.mail = 'El correo electrónico no es válido'
  }
  if (!password) {
    error.password = 'Es necesario que completes este campo.'
  } if (!space) {
    error.password = 'La contraseña no puede contener espacios'
  } else if (!uppercase || !lowercase || !number || !length) {
    error.password =
      'La contraseña debe tener al menos una mayúscula, una minúscula, un número y debe tener entre 8 y 20 caracteres'
  } else if (!regex.test(name)) {
    error.name = 'El nombre solo puede contener letras.'
  } else if (!regex.test(surname)) {
    error.surname = 'El apellido solo puede contener letras.'
  }

  return error
}

export const validatePassword = (password) => {
  const { pass, repeatPassword } = password
  const { uppercase, lowercase, number, length, space } = validateKeyUpPassword(pass)

  const error = {}

  if (!pass) {
    error.pass = 'Es necesario que completes este campo.'
  }
  if (!repeatPassword) {
    error.repeatPassword = 'Es necesario que completes este campo.'
  }
  if (!space) {
    error.pass = 'La contraseña no puede contener espacios'
  }
  if (!uppercase || !lowercase || !number || !length) {
    error.pass =
      'La contraseña debe tener al menos una mayúscula, una minúscula, un número y debe tener entre 8 y 20 caracteres'
  }

  return error
}
